







import Vue from 'vue'
import { PropValidator } from 'vue/types/options'
import { IDevice } from '@/types/model'
import { devIsOnline } from '@/utils'

export default Vue.extend({
  props: {
    device: { } as PropValidator<IDevice>,
  },
  computed: {
    // iconString (): string { return this.online ? 'check_circle' : 'help' },
    color (): string | undefined {
      if (this.device.deviceType === 'RX') {
        return devIsOnline(this.device) && this.device.rxInfo.tvDetected ? '#444444' : '#dddddd'
      } else {
        return devIsOnline(this.device) && this.device.txInfo.sourceDetected ? '#444444' : '#dddddd'
      }
    }
  }
})
